import { c as _c } from "react/compiler-runtime";
import { EXTREMOS_ESCALA, NOTA_MAXIMA } from '../../constants/catalogoMomentos';
import type { PesquisaTipo } from '../../types/pesquisaSatisfacaoTypes';
import { RostoCsat } from './RostoCsat';
interface EscalaPesquisaProps {
  tipo: PesquisaTipo;
  onSelecionar: (nota: number) => void;
  desabilitada?: boolean;
}
const TILE_CSAT: Record<number, string> = {
  1: 'border-error-200 bg-error-50 text-error-600 hover:border-error-600 hover:bg-error-100',
  2: 'border-warning-200 bg-warning-50 text-warning-600 hover:border-warning-600 hover:bg-warning-100',
  3: 'border-neutral-200 bg-neutral-50 text-neutral-500 hover:border-neutral-500 hover:bg-neutral-100',
  4: 'border-success-200 bg-success-50 text-success-500 hover:border-success-500 hover:bg-success-100',
  5: 'border-success-200 bg-success-50 text-success-600 hover:border-success-600 hover:bg-success-100'
};
const NUMERO_CSAT: Record<number, string> = {
  1: 'text-error-700',
  2: 'text-warning-700',
  3: 'text-neutral-600',
  4: 'text-success-700',
  5: 'text-success-700'
};
const TILE_CES: Record<number, string> = {
  1: 'border-error-200 bg-error-50 text-error-700 hover:border-error-600 hover:bg-error-100',
  2: 'border-error-100 bg-error-50 text-error-700 hover:border-error-600 hover:bg-error-100',
  3: 'border-warning-200 bg-warning-50 text-warning-700 hover:border-warning-600 hover:bg-warning-100',
  4: 'border-neutral-200 bg-neutral-50 text-neutral-600 hover:border-neutral-500 hover:bg-neutral-100',
  5: 'border-success-100 bg-success-50 text-success-700 hover:border-success-500 hover:bg-success-100',
  6: 'border-success-200 bg-success-50 text-success-700 hover:border-success-500 hover:bg-success-100',
  7: 'border-success-300 bg-success-50 text-success-700 hover:border-success-600 hover:bg-success-100'
};
export function EscalaPesquisa(t0) {
  const $ = _c(18);
  const {
    tipo,
    onSelecionar,
    desabilitada: t1
  } = t0;
  const desabilitada = t1 === undefined ? false : t1;
  const total = NOTA_MAXIMA[tipo];
  const extremos = EXTREMOS_ESCALA[tipo];
  let t2;
  if ($[0] !== total) {
    t2 = Array.from({
      length: total
    }, _temp);
    $[0] = total;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const notas = t2;
  const isCsat = tipo === "CSAT";
  let t3;
  if ($[2] !== desabilitada || $[3] !== isCsat || $[4] !== notas || $[5] !== onSelecionar || $[6] !== total) {
    t3 = <div className="flex gap-2">{notas.map(nota => <button key={nota} type="button" disabled={desabilitada} onClick={() => onSelecionar(nota)} aria-label={`Nota ${nota} de ${total}`} className={`focus-visible:outline-brand-600 flex flex-1 cursor-pointer flex-col items-center justify-center gap-1 rounded-[10px] border transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-60 ${isCsat ? "h-[60px]" : "h-[46px]"} ${isCsat ? TILE_CSAT[nota] : TILE_CES[nota]}`}>{isCsat ? <RostoCsat nota={nota} /> : null}<span className={`font-semibold ${isCsat ? `text-[11px] font-bold ${NUMERO_CSAT[nota]}` : "text-base"}`}>{nota}</span></button>)}</div>;
    $[2] = desabilitada;
    $[3] = isCsat;
    $[4] = notas;
    $[5] = onSelecionar;
    $[6] = total;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== extremos.minimo) {
    t4 = <span className="text-error-700 text-[11px] font-medium">{extremos.minimo}</span>;
    $[8] = extremos.minimo;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== extremos.maximo) {
    t5 = <span className="text-success-700 text-[11px] font-medium">{extremos.maximo}</span>;
    $[10] = extremos.maximo;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex justify-between px-0.5">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t6) {
    t7 = <div className="flex flex-col gap-2">{t3}{t6}</div>;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp(_, indice) {
  return indice + 1;
}